import { Group } from 'antd/lib/avatar';
import React, { FC } from 'react';
import styled from 'styled-components';
import { PlaceholderAvatar, AvatarProps } from './avatar';

const NO_OF_AVATARS = 3;

const StyledAvatarGroup = styled(Group)<{ gutter: string }>`
  .ant-avatar {
    &:not(:last-child) {
      opacity: 0.5;
    }

    &:not(:first-child) {
      margin-left: ${({ gutter }) => `calc(-1 * ${gutter})`};
    }
  }
`;

interface Props extends Omit<AvatarProps, 'isCustomerRole'> {
  gutter?: string;
}
export const PlaceholderAvatarGroup: FC<Props> = ({
  gutter = 'var(--spacing-03)',
  ...rest
}) => {
  const avatarGroup = Array(NO_OF_AVATARS);

  for (let i = 0; i < NO_OF_AVATARS; i += 1) {
    avatarGroup.push(
      <PlaceholderAvatar key={i} isCustomerRole={false} size={22} {...rest} />,
    );
  }

  return <StyledAvatarGroup gutter={gutter}>{avatarGroup}</StyledAvatarGroup>;
};
